module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng2.401ec043.png";